import React from 'react';
import { Text, View, TextInput, StyleSheet, useWindowDimensions } from 'react-native';
import { IS_WEB } from '../../../shared/utils/platform/getPlatform';
import { colors } from '../constants';
export const Input = _ref => {
  let {
    label,
    value,
    keyboardType,
    error,
    placeholder,
    inputContainerStyle,
    inputStyle,
    onChangeText,
    onSubmitEditing,
    autoFocus
  } = _ref;
  const {
    width
  } = useWindowDimensions();
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, inputContainerStyle]
  }, !!label && /*#__PURE__*/React.createElement(Text, null, label), /*#__PURE__*/React.createElement(TextInput, {
    value: value,
    onChangeText: onChangeText,
    placeholder: placeholder,
    keyboardType: keyboardType,
    onSubmitEditing: onSubmitEditing,
    autoFocus: autoFocus,
    style: [styles.input, {
      ...(width < 768 ? {
        paddingVertical: 8,
        paddingHorizontal: 8
      } : {
        paddingVertical: 4,
        paddingHorizontal: 4
      }),
      ...(IS_WEB ? {
        borderBottom: `1px solid ${colors.neutral300}`
      } : {})
    }, inputStyle]
  }), !!error && /*#__PURE__*/React.createElement(Text, null, error));
};
const styles = StyleSheet.create({
  container: {
    width: '100%'
  },
  input: {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral300,
    fontSize: 16,
    lineHeight: 24,
    width: '100%',
    outlineStyle: 'none',
    outlineWidth: 0
  }
});
//# sourceMappingURL=Input.js.map